import { Text, Box, Collapse } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import { localise } from '../../../services/lang/lang';
const ExpandableContent = ({ isExpanded, collapsedHeight = 72, showExpandText, handleExpandTextClicked, children, }) => {
    const tokens = useTokens();
    const contentRef = useRef(null);
    const [shouldCollapse, setShouldCollapse] = useState(false);
    useEffect(() => {
        const height = contentRef.current?.scrollHeight || 0;
        if (height > collapsedHeight) {
            setShouldCollapse(true);
        }
    }, [children, collapsedHeight]);
    return (React.createElement(Box, { "data-testid": "expandable_content", width: "100%" },
        React.createElement(Collapse, { startingHeight: shouldCollapse ? collapsedHeight : undefined, in: shouldCollapse ? isExpanded : true, animateOpacity: true },
            React.createElement(Box, { ref: contentRef }, children)),
        React.createElement(RenderIf, { condition: shouldCollapse && showExpandText },
            React.createElement(Box, { textAlign: "center", mt: tokens.Spacing03 },
                React.createElement(Text, { variant: "md-600-rg-4", _hover: {
                        textDecoration: 'underline',
                        color: tokens.TextDark800,
                    }, "data-testid": "expandable_content__expand_text", cursor: "pointer", onClick: handleExpandTextClicked }, isExpanded
                    ? `${localise('SHOW_LESS')} ▲`
                    : `${localise('SHOW_MORE')} ▼`)))));
};
export default ExpandableContent;
